package net.dipgo.game

enum class PointState {
    EMPTY,
    A,
    B,
    C,
    D,
    E,
    F,
    G,
    H,
    I;


    fun pointStateToPointStateInt(): Int {
        return when (this) {
            A -> 1
            B -> 2
            C -> 3
            D -> 4
            E -> 5
            F -> 6
            G -> 7
            H -> 8
            I -> 9
            else -> 0
        }
    }

    companion object {
        fun pointStateIntToPointState(int: Int): PointState {
            return when (int) {
                1 -> A
                2 -> B
                3 -> C
                4 -> D
                5 -> E
                6 -> F
                7 -> G
                8 -> H
                9 -> I
                else -> EMPTY
            }
        }

        fun nonEmptyPointStates(): List<PointState> {
            return PointState.values().filterNot { it == EMPTY }
        }
    }
}